export const APP_NAME = 'US Print Factory'
export const PERSIST_STORE_NAME = 'teamuser'
export const APP_PATH = '/landing'
export const REDIRECT_URL_KEY = 'redirectUrl'
